// src/api/services/integrations.js
import apiClient from '../client';

/**
 * API služba pro správu integrací
 */
export const integrationService = {
    /**
     * Získá seznam všech integrací
     * @returns {Promise} - Promise s výsledkem operace
     */
    getIntegrations: () => apiClient.get('/api/integrations'),

    /**
     * Připojí Slack integraci
     * @param {object} data - Data pro připojení
     * @returns {Promise} - Promise s výsledkem operace
     */
    connectSlack: (data) => apiClient.post('/api/integrations/slack', data),

    /**
     * Připojí Discord integraci
     * @param {object} data - Data pro připojení
     * @returns {Promise} - Promise s výsledkem operace
     */
    connectDiscord: (data) => apiClient.post('/api/integrations/discord', data),

    /**
     * Připojí Telegram integraci
     * @param {object} data - Data pro připojení
     * @returns {Promise} - Promise s výsledkem operace
     */
    connectTelegram: (data) => apiClient.post('/api/integrations/telegram', data),

    /**
     * Připojí Asana integraci
     * @param {object} data - Data pro připojení
     * @returns {Promise} - Promise s výsledkem operace
     */
    connectAsana: (data) => apiClient.post('/api/integrations/asana', data),

    /**
     * Připojí Trello integraci
     * @param {object} data - Data pro připojení
     * @returns {Promise} - Promise s výsledkem operace
     */
    connectTrello: (data) => apiClient.post('/api/integrations/trello', data),

    /**
     * Odpojí integraci
     * @param {string} type - Typ integrace (slack, discord, telegram, asana, trello)
     * @returns {Promise} - Promise s výsledkem operace
     */
    disconnectIntegration: (type) => apiClient.delete(`/api/integrations/${type}`),

    /**
     * Otestuje integraci
     * @param {string} type - Typ integrace (slack, discord, telegram, asana, trello)
     * @returns {Promise} - Promise s výsledkem operace
     */
    testIntegration: (type) => apiClient.post(`/api/integrations/${type}/test`),

    /**
     * Aktualizuje nastavení integrace
     * @param {string} type - Typ integrace
     * @param {object} settings - Nastavení integrace
     * @returns {Promise} - Promise s výsledkem operace
     */
    updateSettings: (type, settings) => apiClient.put(`/api/integrations/${type}/settings`, settings),

    /**
     * Získá API klíč pro Webhook API
     * @returns {Promise} - Promise s výsledkem operace
     */
    getApiKey: () => apiClient.get('/api/integrations/api-key'),

    /**
     * Vygeneruje nový API klíč pro Webhook API
     * @returns {Promise} - Promise s výsledkem operace
     */
    regenerateApiKey: () => apiClient.post('/api/integrations/api-key/regenerate'),

    /**
     * Získá historii volání webhook API
     * @param {number} page - Číslo stránky
     * @param {number} limit - Počet záznamů na stránku
     * @returns {Promise} - Promise s výsledkem operace
     */
    getWebhookHistory: (page = 1, limit = 20) => apiClient.get('/api/integrations/webhooks/history', {
        params: { page, limit }
    }),

    /**
     * Získá nastavení Zapier/Make integrace
     * @returns {Promise} - Promise s výsledkem operace
     */
    getZapierSettings: () => apiClient.get('/api/integrations/zapier'),

    /**
     * Aktualizuje nastavení Zapier/Make integrace
     * @param {object} settings - Nastavení integrace
     * @returns {Promise} - Promise s výsledkem operace
     */
    updateZapierSettings: (settings) => apiClient.put('/api/integrations/zapier', settings)
};

export default integrationService;